import { axiosIns } from "../utils";

// The back-office moderates adverts, so it needs the ones still awaiting
// validation. `/publicity/` is the mobile carousel and returns published
// adverts only, whoever asks — pending submissions would have been invisible
// here, which is precisely what has to be reviewed.
export const fetchPublicities = async (params) => {
  const res = await axiosIns.get("/publicity/all/", { params });
  return res && res.data ? res.data : res;
};

export const fetchPublicityById = async (id) => {
  const res = await axiosIns.get(`/publicity/${id}/`);
  return res && res.data ? res.data : res;
};

export const createPublicityApi = async (payload) => {
  const res = await axiosIns.post("/publicity/", payload);
  return res && res.data ? res.data : res;
};

export const updatePublicityApi = async (id, payload) => {
  const res = await axiosIns.patch(`/publicity/${id}/`, payload);
  return res && res.data ? res.data : res;
};

// Validation goes through the dedicated route, not PATCH /publicity/:id/:
// the generic update ignores `published` server-side, so sending it there
// reported "Publicité validée" while the advert stayed a draft.
export const validatePublicityApi = async (id) => {
  const res = await axiosIns.patch(`/publicity/${id}/publish/`);
  return res && res.data ? res.data : res;
};

export const deletePublicityApi = async (id) => {
  const res = await axiosIns.delete(`/publicity/${id}/`);
  return res && res.data ? res.data : res;
};
